var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPerformance = function SvgPerformance(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    stroke: "var(--svg-stroke-color, inherit)",
    viewBox: "0 0 25 24"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "inherit",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    clipPath: "url(#performance_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.5 4.834a11.083 11.083 0 0 0-11 11.169v2.03A1.467 1.467 0 0 0 2.967 19.5h19.066a1.467 1.467 0 0 0 1.467-1.466V16a11.083 11.083 0 0 0-11-11.166"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.5 19.5v-1.1c0-.4.316-1.247.879-1.697S11.704 16 12.5 16s1.559.253 2.121.703S15.5 18 15.5 18.4v1.1M14.5 9l-2 6.6M19.5 15h.01M5.5 15h.01M17.5 12h.01M7.5 12h.01M10.5 10h.01"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "performance_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M.5 0h24v24H.5z"
  })))));
};
export default SvgPerformance;